export * from '@primeuix/themes/material/toolbar';
export { default } from '@primeuix/themes/material/toolbar';
